import { createAction, handleActions } from 'redux-actions';
// - Actions
export const areaListRequest = createAction('AREA_LIST_REQUEST');
export const areaListSuccess = createAction('AREA_LIST_SUCCESS');
export const excelAreaRequest = createAction('EXCEL_AREA_REQUEST');

export const districtsAreaRequest = createAction('DISTRICTS_AREA_REQUEST');
export const wardsAreaRequest = createAction('WARDS_AREA_REQUEST');

export const deleteAreaRequest = createAction('DELETE_AREA_REQUEST');

export const failure = createAction('AREA_ACTION_FAILURE');

// - Initial State
export const initialState = {
  areas: [],
  pagination: {
    Page: 1,
    Size: 50,
    Total: 0
  },
  loading: false,
  error: null,
};

// - Reducers
const reducer = handleActions({
  [areaListRequest]: (state) => ({
    ...state,
    loading: true,
  }),
  [areaListSuccess]: (state, { payload: { areas, pagination } }) => ({
    ...state,
    areas: areas,
    pagination: pagination,
    loading: false,
  }),

  [failure]: (state, action) => ({
    ...state,
    loading: false,
    error: action.error,
  }),
}, initialState);

export default reducer;
